export default __webpack_public_path__ + "static/logo-kolyy-cfe2d29968fa063e9ed983feb729c151.png";